import { render, staticRenderFns } from "./ReportHistory.vue?vue&type=template&id=9ecb4ae0&scoped=true"
import script from "./ReportHistory.vue?vue&type=script&lang=js"
export * from "./ReportHistory.vue?vue&type=script&lang=js"
import style0 from "./ReportHistory.vue?vue&type=style&index=0&id=9ecb4ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb4ae0",
  null
  
)

export default component.exports